import { LazyLoadImage } from "react-lazy-load-image-component";
import { useTranslation } from "react-i18next";
export default function VoiceOfEmployees(){
    const { t } = useTranslation();
    return(
        <article>
          <section class="what-we-do employees-voice mt-5">
            <div class="container">
              <div class="row">
                <div class="col">
                  <div class="content-wrapper">
                    <div class="row">
                        <div class="col">
                            <div class="section-title">
                                <h4>{t('home.vibrantworkplace.voiceofemployees')}</h4>
                            </div>
                        </div>
                    </div>
                    <div class="row voices-row">
                      <div class="col-md-4 mb-3">
                        <div class="card testimonials">
                          <div class="quote"></div>
                          <div class="voice">
                            <p>{t('home.vibrantworkplace.testimonial1')}</p>
                          </div>
                          <div class="divider"></div>
                          <div class="user">
                            <div class="row" style={{"align-items": "center"}}>
                              <div class="col-3">
                                <div class="profile-pic">
                                  <LazyLoadImage src={require("../../images/vasugidevi.jpg")}/>
                                </div>
                              </div>
                              <div class="col-8" style={{"align-items": "center"}}>
                                <div class="info">
                                  <div class="name">Vasugidevi</div>
                                  <div class="department">DevOps & Middleware</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-4 mb-3">
                        <div class="card testimonials">
                          <div class="quote"></div>
                          <div class="voice">
                            <p>{t('home.vibrantworkplace.testimonial2')}</p>
                          </div>
                          <div class="divider"></div>
                          <div class="user">
                            <div class="row" style={{"align-items": "center"}}>
                              <div class="col-3">
                                <div class="profile-pic">
                                    <LazyLoadImage src={require("../../images/varatharaj.jpg")}/>
                                </div>
                              </div>
                              <div class="col-8" style={{"align-items": "center"}}>
                                <div class="info">
                                  <div class="name">Varatharaj</div>
                                  <div class="department">Credits</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </article>
    )
}